<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("houseBills.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Year-Month"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :style="{ maxWidth: '150px', height: '38px !important' }"
                      v-on="on"
                      clearable
                      class="pa-0 ma-0 mr-4"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.menu.save(date);
                        getBills();
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="bills"
            :search="search"
          >
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
                <template v-slot:item.member_house="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                   {{ item.member_flat ? item.member_flat + ' - '  + item.member_house : item.member_house }} 
                </div>
              </template>
              <template v-slot:item.description="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:item.type="{ item }">
                <div style="max-width: 150px">
                  {{ types[item.type  ] }}
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ getFormattedDate(item.created_at) }}
              </template>
               <template v-slot:item.paid_date="{ item }">
                {{ item.is_paid == 0 ? "" : getFormattedDate(item.paid_date) }}
                 <v-btn
                    icon
                    color="secondary"
                    name="view_notice"
                    title="Edit "
                    @click="openDocument(item.bill_document)"
                    style="float: right"
                    v-if="item.bill_document!='' && item.bill_document!=null"
                  >
                    <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>

              </template>
              <template v-slot:item.is_paid="{ item }">
                <router-link to="" tag="button">
                  <v-btn :class="item.is_paid==0 ? 'pending ' : 'completed'" @click="updateBillStatusDialog(item);"  color="white"> {{item.is_paid == "0" ? "Pending" :  "Completed"}}
                  </v-btn>
                </router-link>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text >
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-dialog v-model="billStatusDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
           Bill Status
          </v-card-title>
          <v-card-text class="mt-2">
              <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("houseBills.headers.member")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                     {{houseBill_details.member_name}}
                    </v-col>
                  </v-row>

                   <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("houseBills.headers.house")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                     {{ houseBill_details.member_flat ? houseBill_details.member_flat + ' - '  + houseBill_details.member_house : houseBill_details.member_house }}
                    </v-col>
                  </v-row>
                   <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("houseBills.headers.amount")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                     {{houseBill_details.amount}}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("houseBills.headers.date")}` }} :
                      </span>
                    </v-col>
                    <v-col cols="8" xs="8" sm="8" md="9">
                     {{  getFormattedDate(houseBill_details.created_at)  }}
                    </v-col>
                  </v-row>

                  <v-row>
                  <v-col cols="4" xs="4" sm="4" md="3">
                      <span class="h2 font-weight-bold"
                        >{{ `${this.$t("houseBills.headers.status")}` }} :
                      </span>
                  </v-col>
                   <v-col cols="8" xs="8" sm="8" md="9">
                    <v-select
                      v-model="status"
                      :items="types"
                      item-text="text"
                      item-value="value"  
                    />
                  </v-col>
                  </v-row>

                <!-- <v-row>
                <v-col cols="12" xs="12" sm="12" md="12">
                  <v-file-input
                    v-model="documents"
                    label="Bill Documents"
                    multiple
                    prepend-icon="mdi-camera"
                    hint="Only jpg, png, gif, pdf, jpeg, svg file types are allowed"
                    persistent-hint
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input>
                </v-col>
              </v-row> -->

                </v-col>
              </v-row>
            </v-form>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="updateBillStatus()">
              Update
            </v-btn>
            <v-btn color="primary" text @click="houseBill_details={},billStatusDialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("houseBills.headers.member")}`,
          value: "member_name",
        },
        {
          text: `${this.$t("houseBills.headers.house")}`,
          value: "member_house",
          class: "text-truncate",
        },
        {
          text: `${this.$t("houseBills.headers.title")}`, 
          value: "title"
        },
        {
          text: `${this.$t("houseBills.headers.amount")}`,
          value: "amount",
        },
        {
          text: `${this.$t("houseBills.headers.date")}`,
          value: "created_at",
        },
        {
          text: `${this.$t("houseBills.headers.status")}`,
          value: "is_paid",
          sortable: false,
        },
         {
          text: `${this.$t("houseBills.headers.paid_date")}`,
          value: "paid_date",
          sortable: false,
        },
     
      ],
      types: [
        {
          text: "Pending",
          value: 0,
        },
        {
          text: "Completed",
          value: 1,
        },
       
      ],
      status:"",
      user: {},
      deleteDialog: false,
      bills: [],
      delete_id: null,
      billStatusDialog :false,
      houseBill_details:{},
      documents:[],
      base_url: process.env.VUE_APP_API_URL,
  
      menu: false,
      date: null,
    };
  },
  watch: {
    date: function() {
      this.getBills();
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    openDocument(item) {
      window.open(`${this.base_url}/uploads/${item}`, "_blank");
    },
    updateBillStatusDialog(item){
        this.documents = [];
        this.houseBill_details = {};
        this.billStatusDialog = true;
        this.houseBill_details = item;
        this.status= item.is_paid
    },
    updateBillStatus(){
     let _self= this;
      let formData = new FormData();
        if (this.documents) {
          for (let i = 0; i < this.documents.length; i++) {
            console.log(this.documents[i], 'this.documents[i]');
            formData.append("documents[]", this.documents[i]);
          }
        }
       formData.append("status", this.status);
       let url = `societyadmin/bills/house/${this.houseBill_details.id}/updateStatus`;
          _self.$axios.post(url, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;
              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                this.getBills();
                this.billStatusDialog=false;
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
     },            
    getBills() {
      let month, year;
      this.date ? month = moment(this.date,"YYYY-MM").get('month')+1 : "";
      this.date ? year = moment(this.date,"YYYY-MM").get('year') : "";

      let url = `societyadmin/bills/house/bills?society_id=${this.user.id}&perPage=99999999999`;

      this.date ? url = url + `&month=${month}&year=${year}` : "";

      let _self = this;
      _self.$axios
        .get(url)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.bills = data.housebills;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    sessionStorage(search) {
      if (!search) {
        sessionStorage.removeItem("bill_search");
      } else {
        sessionStorage.setItem("bill_search", search);
      }
    },
    confirmDelete(id) {
      this.deleteDialog = true;
      this.delete_id = id
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.date = moment().year() +'-'+ (moment().month()+1);
    this.getBills();
    this.search = sessionStorage.getItem("bill_search");
  },
};
</script>
<style scoped>
.pending{
 background-color: #eedd14 !important; 
 border-color: #eedd14 !important;
 color: #ffffff;
}

.completed{
 background-color: #09ad20 !important; 
 border-color: #09ad20 !important;
 color: #ffffff;
}
.not-allowed
{
  cursor: not-allowed;
}

</style>
